// src/components/PropiedadesDestacadas.js
import React from 'react';
import ListadoPropiedadesPublicas from './ListadoPropiedadesPublicas';

export default function PropiedadesDestacadas() {
  return <ListadoPropiedadesPublicas titulo="Propiedades destacadas" />;
}
